import {
  addCircleOutline,
  removeCircleOutline,
  lockClosed,
  mail,
  createOutline,
  logOut,
  person,
  phonePortrait,
  bug,
  list,
} from "ionicons/icons";
import { ReactElement, useContext, useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Container from "../../components/atoms/Container";
import Icon from "../../components/atoms/Icon";
import AuthContext from "../../contexts/AuthContext";
import { useConfig } from "../../contexts/ConfigContext";
import { isPasswordSignInMethod } from "../../types/profile";
import ChangeEmailModal from "./ChangeEmailModal";
import ChangeNicknameModal from "./ChangeNicknameModal";
import ChangePhoneNumberModal from "./ChangePhoneNumberModal";
import ChangePwdModal from "./ChangePasswordModal";
import LeaveStudyModal from "./LeaveStudyModal";
import LegalMentionModal from "./LegalMentionModal";
import ReportBugModal from "./ReportBugModal";
import { useResonanceLayout } from "../../components/organisms/ResonanceContext/ResonanceLayoutContext";
import { useHistory, useParams } from "react-router"; // Added this line
import { resetCaches } from "../../services/questionnaire.service"; // Add this line
import {
  InvitationChannelDisplayType,
  InvitationChannelEnum,
  sendInvitationFormType,
} from "../../types/invitation.types";
import { sendEmail } from "../../services/email.service";
import LanguageSelectorModal from "../../components/molecules/LanguageSelector/LanguageSelectorModal/LanguageSelectorModal";
import { languageOutline } from "ionicons/icons";
import ResonanceLayout from "../../components/organisms/ResonanceContext/ResonanceLayout";
import {
  useIonRouter,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";

const Profile = (): ReactElement => {
  const { user, endSession, getCurrent } = useContext(AuthContext); // Modified to include endSession
  const { study_slug } = useParams<{ study_slug: string }>(); // Added this line
  const { study } = useConfig();
  const [channel, setChannel] = useState<InvitationChannelDisplayType>();
  const history = useHistory(); // Added this line

  const ionRouter = useIonRouter();

  const handleDisconnect = async () => {
    await endSession();
    resetCaches();
    console.log("study slug:", study_slug); // Log the study slug
    ionRouter.push(`/${study_slug}/welcome`, "root", "replace", {
      unmount: true,
    });
    // history.replace(`/${study_slug}/welcome`);
  }; // Added this function

  const [isLeaveStudyModalOpen, setIsLeaveStudyModalOpen] = useState(false);
  const [isChangeEmailModalOpen, setIsChangeEmailModalOpen] = useState(false);
  const [isChangePhoneNumberModalOpen, setIsChangePhoneNumberModalOpen] = useState(false);
  const [isChangeNicknameModalOpen, setIsChangeNicknameModalOpen] = useState(false);
  const [isChangePwdModalOpen, setIsChangePwdModalOpen] = useState(false);
  const [isLegalMentionOpen, setIsLegalMentionOpen] = useState(false);
  const [isReportBugOpen, setIsReportBugOpen] = useState(false);
  const { selectedRole } = useConfig();

  const { setResonanceLayout } = useResonanceLayout();
  const theme = useTheme();

  // useEffect(() => {
  //   setResonanceLayout({ });
  // }, []);

  useIonViewWillEnter(() => {
    setResonanceLayout({
      disableHeader: false,
      disableNav: false,
      backgroundColor: "white",
      title: "profile_account",
      welcomePage: false,
    });
  });

  // useIonViewWillLeave(() => {
  //   setResonanceLayout({
  //     disableHeader: false,
  //     disableNav: false,
  //     backgroundColor: "white",
  //     title: "profile_account",
  //     welcomePage: false,
  //   });
  // });

  const canChangePassword = useMemo(
    () => isPasswordSignInMethod(selectedRole?.access?.signInMode),
    [selectedRole]
  );

  // const checkFakeEmail = (email) => /^user_.*@etudementalo\.fr$/.test(email) ? "" : email
  // helper to validate "real" email
  const getValidEmail = (email?: string) => {
    if (!email) return null;
    if (/^user_.*@etudementalo\.fr$/.test(email)) return null; // fake email
    return email;
  };

  const validEmail = getValidEmail(user.attributes.email);
  const pendingEmail = getValidEmail(user.pending_email);

  // helper to validate "real" phone
  const getValidPhone = (phone?: string) => {
    if (!phone) return null;
    if (phone === "0607080910") return null; // fake phone
    return phone;
  };

   const getValidNickname = (nickname?: string) => {
    if (!nickname) return null;
    if (nickname.trim() === "") return null;
    return nickname;
  };

  const { t } = useTranslation();

  const handleMentionLegal = () => {
    setIsLegalMentionOpen(true);
  };

  const handleOptOut: () => void = function () {
    setIsLeaveStudyModalOpen(true);
  };

  const handleChangePassword: () => void = function () {
    setIsChangePwdModalOpen(true);
  };

  const handleChangeEmail: () => void = function () {
    setIsChangeEmailModalOpen(true);
  };

  const handleChangePhoneNumber: () => void = function () {
    setIsChangePhoneNumberModalOpen(true);
  };

  const handleChangeNickname: () => void = function () {
    setIsChangeNicknameModalOpen(true);
  };
  const [langModalVisible, setLangModalVisible] = useState(false);
  const validPhone = getValidPhone(user.attributes.phone_number);
  const pendingPhone = getValidPhone(user.pending_phone_number);
  const validNickname = getValidNickname(user.attributes.nickname);
  const [pendingEmailExpiresInSeconds, setPendingEmailExpiresInSeconds] = useState(user.pending_email_expires_in_seconds || 0);
  const [pendingPhoneExpiresInSeconds, setPendingPhoneExpiresInSeconds] = useState(user.pending_phone_number_expires_in_seconds || 0);
  const canChangeNickname = canChangePassword;
  const displayEmail = pendingEmail || validEmail;
  const displayPhone = pendingPhone || validPhone;
  const hasEmailValue = Boolean(displayEmail);
  const hasPhoneValue = Boolean(displayPhone);
  const showEmailField = hasEmailValue || canChangePassword;
  const showPhoneField = hasPhoneValue || canChangePassword;
  const pendingEmailHint = pendingEmail
    ? validEmail
      ? t("profile_pending_email_replace_hint")
      : t("profile_pending_email_hint")
    : null;
  const pendingPhoneHint = pendingPhone
    ? validPhone
      ? t("profile_pending_phone_replace_hint")
      : t("profile_pending_phone_hint")
    : null;

  useEffect(() => {
    setPendingEmailExpiresInSeconds(user.pending_email_expires_in_seconds || 0);
  }, [user.pending_email_expires_in_seconds, user.pending_email]);

  useEffect(() => {
    setPendingPhoneExpiresInSeconds(user.pending_phone_number_expires_in_seconds || 0);
  }, [user.pending_phone_number_expires_in_seconds, user.pending_phone_number]);

  useEffect(() => {
    if (!pendingEmail || pendingEmailExpiresInSeconds <= 0) {
      return;
    }

    const timer = window.setInterval(() => {
      setPendingEmailExpiresInSeconds((currentSeconds) => {
        if (currentSeconds <= 1) {
          window.clearInterval(timer);
          void getCurrent();
          return 0;
        }

        return currentSeconds - 1;
      });
    }, 1000);

    return () => window.clearInterval(timer);
  }, [getCurrent, pendingEmail, pendingEmailExpiresInSeconds]);

  useEffect(() => {
    if (!pendingPhone || pendingPhoneExpiresInSeconds <= 0) {
      return;
    }

    const timer = window.setInterval(() => {
      setPendingPhoneExpiresInSeconds((currentSeconds) => {
        if (currentSeconds <= 1) {
          window.clearInterval(timer);
          void getCurrent();
          return 0;
        }

        return currentSeconds - 1;
      });
    }, 1000);

    return () => window.clearInterval(timer);
  }, [getCurrent, pendingPhone, pendingPhoneExpiresInSeconds]);

  return (
    // <ResonanceLayout isConnected>
    <Container>
      <Section>
        {/* <Header>{t("profile_account")}</Header> */}
        {/* <Field>
          <Icon icon={person} />
          <FieldTitle>{t("profile_name")}</FieldTitle>
          <FieldValue>
            {user.attributes.firstname} {user.attributes.lastname}
          </FieldValue>
        </Field> */}

        {showEmailField && (
          <Field>
            <Icon icon={mail} />
            <FieldLabelGroup>
              <FieldTitleRow>
                <FieldTitle>{t("profile_email")}</FieldTitle>
                {pendingEmail && (
                  <PendingBadge>
                    {t("profile_pending_confirmation")}
                  </PendingBadge>
                )}
              </FieldTitleRow>
              {pendingEmailHint && <FieldHint>{pendingEmailHint}</FieldHint>}
            </FieldLabelGroup>
            <FieldValue $isPlaceholder={!displayEmail}>
              {displayEmail || t("profile_not_provided")}
            </FieldValue>
            {canChangePassword && (
              <FieldActionButton
                type="button"
                onClick={handleChangeEmail}
                aria-label={
                  hasEmailValue ? t("profile_change_email") : t("profile_add_email")
                }
              >
                <Icon icon={hasEmailValue ? createOutline : addCircleOutline} />
              </FieldActionButton>
            )}
          </Field>
        )}

        {showPhoneField && (
          <Field>
            <Icon icon={phonePortrait} />
            <FieldLabelGroup>
              <FieldTitleRow>
                <FieldTitle>{t("profile_phone")}</FieldTitle>
                {pendingPhone && (
                  <PendingBadge>
                    {t("profile_pending_confirmation")}
                  </PendingBadge>
                )}
              </FieldTitleRow>
              {pendingPhoneHint && <FieldHint>{pendingPhoneHint}</FieldHint>}
            </FieldLabelGroup>
            <FieldValue $isPlaceholder={!displayPhone}>
              {displayPhone || t("profile_not_provided")}
            </FieldValue>
            {canChangePassword && (
              <FieldActionButton
                type="button"
                onClick={handleChangePhoneNumber}
                aria-label={
                  hasPhoneValue ? t("profile_change_phone") : t("profile_add_phone")
                }
              >
                <Icon icon={hasPhoneValue ? createOutline : addCircleOutline} />
              </FieldActionButton>
            )}
          </Field>
        )}

          {/* Pseudonym field only if not null/empty */}
        {(validNickname || canChangeNickname) && (
          <Field>
            <Icon icon={person} />
            <FieldTitle>{t("profile_pseudonym")}</FieldTitle>
            <FieldValue>{validNickname}</FieldValue>
            {canChangeNickname && (
              <FieldActionButton
                type="button"
                onClick={handleChangeNickname}
                aria-label={t("profile_change_nickname")}
              >
                <Icon icon={createOutline} />
              </FieldActionButton>
            )}
          </Field>
        )}

        {canChangePassword && (
          <Field onClick={handleChangePassword}>
            <Icon icon={lockClosed} />
            <FieldTitle>{t("profile_change_password")}</FieldTitle>
          </Field>
        )}

      </Section>

      <Section>
        <Header>{t("profile_study_info")}</Header>

        <Field onClick={handleOptOut}>
          <Icon icon={removeCircleOutline} />
          <FieldTitle>{t("profile_opt_out")}</FieldTitle>
        </Field>

        <Field onClick={handleMentionLegal}>
          <Icon icon={list} />
          <FieldTitle>{t("mention_legal")}</FieldTitle>
        </Field>

        <Field onClick={() => setIsReportBugOpen(true)}>
          <Icon icon={bug} />
          <FieldTitle>{t("profile_report_bug")}</FieldTitle>
        </Field>

        <Field onClick={() => setLangModalVisible(true)}>
          <Icon icon={languageOutline} />
          <FieldTitle >
            {t("profil_langue")}
          </FieldTitle>
        </Field>

        {/* <Field onClick={handleDisconnect}>
          <Icon icon={logOut} />
          <FieldTitle>{t("menu_logOut")}</FieldTitle>
        </Field> */}
      </Section>

      <LeaveStudyModal
        onDismiss={() => setIsLeaveStudyModalOpen(false)}
        isOpen={isLeaveStudyModalOpen}
      />
      <ChangePwdModal
        onDismiss={() => setIsChangePwdModalOpen(false)}
        isOpen={isChangePwdModalOpen}
      />
      <ChangeEmailModal
        onDismiss={() => setIsChangeEmailModalOpen(false)}
        isOpen={isChangeEmailModalOpen}
        hasExistingEmail={Boolean(validEmail)}
      />
      <ChangePhoneNumberModal
        onDismiss={() => setIsChangePhoneNumberModalOpen(false)}
        isOpen={isChangePhoneNumberModalOpen}
        hasExistingPhoneNumber={Boolean(validPhone)}
      />
      <ChangeNicknameModal
        onDismiss={() => setIsChangeNicknameModalOpen(false)}
        isOpen={isChangeNicknameModalOpen}
      />
      <LegalMentionModal
        onDismiss={() => setIsLegalMentionOpen(false)} // Close Legal Mention Modal
        isOpen={isLegalMentionOpen} // Control modal visibility
      />
      <LanguageSelectorModal
        modalVisible={langModalVisible}
        onCloseClick={() => setLangModalVisible(false)}
      />

      <ReportBugModal
        isOpen={isReportBugOpen}
        onDismiss={() => setIsReportBugOpen(false)}
        user={user}
        study={study}
      />
    </Container>
    // </ResonanceLayout>
  );
};

const Section = styled.div`
  background-color: white;
`;

const Header = styled.div`
  background-color: ${(props) => props.theme.primary.background};
  padding: 20px;
  color: ${(props) => props.theme.primary.contrast};
  margin-bottom: 10px;
  font-size: 18px;
`;

const Field = styled.div.attrs({ tabIndex: 0 })<
  React.HTMLAttributes<HTMLDivElement>
>`
  display: flex;
  flex-direction: row;
  padding: 10px;
  align-items: center;
  font-size: 16px;
  ion-icon {
    font-size: 22px;
    color: ${(props) => props.theme.primary.main};
  }

  > ion-icon {
    flex: 0 0 22px;
    min-width: 22px;
  }
`;

const FieldTitle = styled.div`
  color: #747474;
  margin-left: 5px;
  flex: 1 1 auto;
  min-width: 0px;
`;

const FieldLabelGroup = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

const FieldTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const PendingBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #fff4d6;
  color: #8a5a00;
  font-size: 12px;
  font-weight: 600;
`;

const FieldHint = styled.div`
  margin-left: 5px;
  margin-top: 4px;
  color: #8a5a00;
  font-size: 13px;
  line-height: 1.4;
`;

const FieldValue = styled.div<{ $isPlaceholder?: boolean }>`
  color: ${(props) =>
    props.$isPlaceholder ? "#747474" : props.theme.primary.main};
  margin-left: 12px;
  text-align: right;
  word-break: break-word;
`;

const FieldActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 8px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  color: ${(props) => props.theme.primary.main};

  ion-icon {
    font-size: 20px;
    color: ${(props) => props.theme.primary.main};
  }
`;

export default Profile;
